/**
 * @description Тип документ.
 * @type {string}
 */
export const DOCUMENT_TYPE = 'document';

/**
 * @description Тип договор.
 * @type {string}
 */
export const CONTRACT_TYPE = 'contract';

/**
 * @description Тип шаблона.
 */
class TemplateType {
  /**
   * @description Конструктор
   * @param title {string}
   * @param value {string}
   */
  constructor(title, value) {
    if (![DOCUMENT_TYPE, CONTRACT_TYPE].includes(value)) {
      return;
    }
    this.title = title;
    this.value = value;
  }
}

/**
 * @description Типы шаблонов
 * @type {Array<TemplateType>}
 */
const TEMPLATE_TYPES = [
  new TemplateType('Документ', DOCUMENT_TYPE),
  new TemplateType('Договор', CONTRACT_TYPE),
];

/**
 * @description Типы шаблонов.
 * @type {TemplateType[]}
 */
export default {
  data() {
    return {
      /**
       * @description Тип файла.
       * @type {TemplateType}
       */
      type: TEMPLATE_TYPES[0].value,
      /**
       * @description Типы шаблонов
       * @type {Array<TemplateType>}
       */
      templateTypes: TEMPLATE_TYPES,
    };
  },
};
